import styled, { css } from 'styled-components';

import { Text } from '@/nova/components';
import { CFG, CFG_CHROME } from '../../../../../theme/configurator-tokens';

/**
 * `$pill`: the fully-rounded, fill-height variant used when the switcher sits beside the
 * "Live Preview" pill (the tablet control bar), so the two controls share a corner radius
 * and the active option fills the row height instead of floating as a small inner pill.
 * The default (Figma 1657-14835) look is unchanged everywhere it stands alone.
 */
export const Switch = styled.div<{ $pill?: boolean }>`
  display: inline-flex;
  align-items: ${({ $pill }) => ($pill ? 'stretch' : 'center')};
  gap: 8px;
  border-radius: ${({ $pill }) => ($pill ? '9999px' : '14px')};
  background: ${CFG.base100};
  padding: 4px;
`;

export const Option = styled(Text)<{ $active?: boolean; $pill?: boolean }>`
  cursor: pointer;
  border-radius: ${({ $pill }) => ($pill ? '9999px' : '12px')};
  padding: ${({ $pill }) => ($pill ? '4px 18px' : '4px 12px')};
  font-size: 14px;
  line-height: 20px;
  transition: color 150ms ease, background-color 150ms ease;
  color: ${({ $active }) => ($active ? CFG.foreground : CFG.base400)};
  background: ${({ $active }) => ($active ? CFG.forceDark : 'transparent')};
  box-shadow: ${({ $active }) => ($active ? CFG_CHROME.switchShadow : 'none')};
  /* Centre the label within the stretched height so the active pill reads as a full,
     rounded segment matching the Live Preview pill. */
  ${({ $pill }) =>
    $pill &&
    css`
      display: flex;
      align-items: center;
      justify-content: center;
    `}

  &:hover {
    color: ${({ $active }) => ($active ? CFG.foreground : CFG.base300)};
  }
`;
